import axios from 'axios';
import constants from '../constants';
// import authService from '../auth/AuthService'; // acquire token from getters['oidcStore/oidcAccessToken']
import moment from 'moment';
import { forecasts } from './devdata';

export default {
  getFromDate(forecastKey, startDate, teamFilter) {
    return new Promise((resolve, reject) => { resolve(forecasts); });
    // return new Promise(function(resolve, reject) {
    //   authService.acquireToken(['api://6b77f60e-8f2e-4d88-8f34-fb827da6f495/planning.read'])
    //   .then(accessToken => {
    //     const headers = { 'Authorization': `Bearer ${accessToken}` };
    //     const options = {
    //       headers
    //     };
    //     axios.get(`${constants.planningApiBasePath}/forecasts/?key=${forecastKey}&fromdate=${moment(startDate).format('YYYY-MM-DD')}&forteam=${(teamFilter ? teamFilter : '')}`, options)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(error => {
    //         reject(error);
    //       });
    //   }).catch(error => {
    //     reject(error);
    //   });
    // });
  },
};
